<script lang="ts" setup>
import type {Author} from "~/types/mgnl";
import {useAuthor} from "~/composables/useAuthor";
import type {
  FocalPointAsset,
  FromResolver,
} from "#magnolia-layer/types/magnolia-types";

const props = defineProps<{
  title?: string;
  text?: string;
  image: FromResolver<FocalPointAsset>;
  grayscale: boolean;
}>();

// Props
const propAuthor = inject<string | undefined>("author");
const spineTitleState = useState("spineTitle");
const propAbstract = inject<string | undefined>("abstract");
const headerTitle = props.title ?? spineTitleState.value; // make sure the get the value to not make it reactive

const authorResponse = propAuthor ? await useAuthor([propAuthor]) : undefined;
const author = authorResponse ? authorResponse[0] : undefined;

const addModifiers = computed(() => {
  if (props.grayscale) {
    return {grayscale: 1};
  }
});
</script>

<template>
  <div
    class="header__image col-span-full bg-black py-8 lg:py-20 px-4 flex justify-center items-center lg:min-h-112 max-h-[75vh] aspect-video lg:aspect-auto">
    <MagnoliaPicture
      :modifiers="addModifiers"
      :asset="image"
      sizes="320 lg:576"
      class="max-w-full sm:max-w-md lg:max-w-xl">
    </MagnoliaPicture>
  </div>
  <div class="inner-content-grid">
    <Breadcrumb></Breadcrumb>
    <h1 class="text-4xl lg:text-7xl mt-7 mb-16">{{ headerTitle }}</h1>
  </div>

  <AuthorBlock v-if="author" :author="author"> </AuthorBlock>

  <div v-if="propAbstract || text" class="inner-content-grid">
    <template v-if="text">
      <div class="text-xl lg:text-3xl mb-4" v-html="text"></div>
    </template>
    <p v-else class="text-xl lg:text-3xl mb-4">{{ propAbstract }}</p>
  </div>
</template>

<style lang="scss" scoped>
.header__image {
  :deep(picture) {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 100%;

    img {
      max-height: 100%;
    }
  }
}
</style>
